import $ from 'jquery';

import { Component } from '../core/component';

export class CalendarCategories extends Component {
    constructor() {
        super();
        this.selector = '.js-calendar-categories';
        this.$form = null;
    }

    init() {
        this.$form = $('.js-calendar-form');

        this.$elements.on('change', () => {
            const value = this.$elements.val();
            const $input = this.$form.find('input[name=category]');

            if (!value) {
                $input.remove();
                return this.$form.trigger('submit');
            }

            if ($input.length > 0) {
                $input.val(value);
            } else {
                this.$form.append(`<input type="hidden" name="category" value="${value}">`);
            }

            this.$form.trigger('submit');
        });
    }
}



// WEBPACK FOOTER //
// ./assets/js/components/calendarCategories.js